module.exports = __webpack_public_path__ + "img/ending_arrow_hover.523af722.svg";